export const SITEMAP_PATH = '/sitemap/';

export const SITEMAP_LANDING_NAME = 'sitemap';

export const SITEMAP_ELEMENT_BLOCK = 'sitemap';

export const TOP_LEVEL_NAME_MAP: Record<string, string> = {
  '/catalogue/': 'Товары',
  '/uslugi/': 'Проекты и услуги',
};
